import React, { ReactFragment } from "react";

let availableTags : string[] = ['p', 'ol', 'ul', 'li', 'br', 'b'];

interface IState {
    domParser: DOMParser;
}

export default class ReactFromHtml implements IState {
    readonly domParser: DOMParser

    constructor()
    {
        this.domParser = new DOMParser();
    }

    public parseToFragment(html: string) : ReactFragment
    {
        let doc = this.domParser.parseFromString(html, "text/html");
        return React.createElement(React.Fragment, {}, this.nodesToReact(doc.body.childNodes));
    }

    private nodesToReact(nodes : ArrayLike<Node>) : Array<React.ReactNode>
    {
        let reactNodes: Array<React.ReactNode> = [];
        for (let i = 0, len = nodes.length; i < len; i++) {
            let reactNode = this.elementToReactNode(nodes[i], i.toString())
            reactNodes.push(reactNode);
          }
          return reactNodes;
    }

    private elementToReactNode(node: Node, elementKey: string) : React.ReactNode 
    {
        let nodeName = node.nodeName.toLowerCase();
        if (nodeName === "#text"){
            return (node as Text).data;
        }
        else if (availableTags.includes(nodeName)){
            return React.createElement(nodeName, {key: elementKey}, this.nodesToReact(node.childNodes))
        }
    }
}